<template>
    <div class="layout-container">
        <el-tabs type="border-card">
            <el-tab-pane :label="`${condition.name} 消费记录`">
                <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con" :class="isShowMore && 'show'">
                        <div class="search-condition search-condition-time-2">
                            <span class="label">时间段</span>
                            <div>
                                <a class="quckily" @click="checkDate('month')" :class="condition.timeStamp === 'month' && 'active'">最近30天</a>
                                <a class="quckily" @click="checkDate('doubleMonth')" :class="condition.timeStamp === 'doubleMonth' && 'active'">最近60天</a>
                            </div>
                            <div class="input-condition">
                                <el-date-picker
                                        v-model="condition.time"
                                        type="datetimerange"
                                        range-separator="至"
                                        start-placeholder="请选择开始日期"
                                        end-placeholder="请选择结束日期"
                                        align="right"
                                        @change="condition.timeStamp = ''"
                                >
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch()">查 询</el-button>
                    </div>
                </div>
                <div class="clearfix" style="margin-bottom: 5px">
                    <el-button-group class="floatR">
                        <el-tooltip class="item" effect="dark" content="导出" placement="top">
                            <el-button icon="el-icon-download" @click="download"></el-button>
                        </el-tooltip>
                    </el-button-group>
                </div>
                <el-table
                        :data="list"
                        style="width: 100%"
                        :highlight-current-row="true"
                        stripe
                        tooltip-effect="dark"
                        ref="multipleTable"
                        v-loading="isLoading"
                        header-cell-class-name="table-back"
                >
                    <!--  -->
                    <!-- 表头：label对应展示的名称 prop对应返回数据列表中绑定的字段名 sortable:标识当前列是否允许排序 -->

                    <el-table-column  label="代理商名称" prop="factor_name"></el-table-column>
                    <el-table-column  label="消费站点" prop="site_name"></el-table-column>
                    <el-table-column  label="消费类型" prop="fee_type"></el-table-column>
                    <el-table-column  label="应付金额（元）" prop="payable_amount"></el-table-column>
                    <el-table-column  label="实付金额（元）" prop="paid_amount"></el-table-column>
                    <el-table-column  label="时间" prop="created_at"></el-table-column>
                </el-table>
                <!--  total：一共有多少条数据 page-size一个页面显示多少条数据 @current-change当点击分页数触发-->
                <template v-if="list.length > 0">
                    <!-- :total="list.length" -->
                    <el-pagination background layout="total,prev, pager, next" :current-page="condition.page"  :total="condition.total" :page-size="condition.per_page" @current-change="currentChange"></el-pagination>
                </template>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    import { parseTime } from '@/utils'
    import {  getFactorsList } from '@/service/user'
    import { getSite } from '@/service/site'
    import {getQueryObject} from '@/utils/index'
    import { factorExpenseRecord }  from '@/service/payment'
    export default {
        name: 'Expense',
        components: {
        },
        data () {
            return {
                condition: {
                    id : 0,
                    name: '',
                    time: '',
                    timeStamp: 'month',
                    total : 0,
                    per_page : 10,
                    page : 1,
                },
                total_self_recharge:0,
                total_free:0,
                total_400:0,
                total_fee:0,
                isLoading: false, // 是否显示loading加载
                list: [],
            }
        },
        mounted () {
            let query = getQueryObject()
            if (!query.id || !query.name) {
                this.$router.push('list')
            }
            this.condition.id = query.id
            this.condition.name = query.name
            this.initData()
        },
        methods: {
            handleSearch() {
                this.condition.page = 1
                this.initData()
            },
            resetSearch() {
                this.condition = {
                    time: '',
                    timeStamp: 'month',
                    total : 0,
                    per_page : 10,
                    page : 1,
                }
                this.initData()
            },

            /** 初始化数据请求 */
            async initData () {
                let query = {
                    factor_id : this.condition.id,
                    page : this.condition.page,
                    per_page : this.condition.per_page
                }
                if (this.condition.timeStamp.length > 0) {
                    query.time_quantum = this.condition.timeStamp == 'month' ? 30 : 60
                } else if(this.condition.time && this.condition.time.length > 0) {
                    query.start_time = Date.parse(new Date(this.condition.time[0]))/1000
                    query.end_time = Date.parse(new Date(this.condition.time[1]))/1000
                } else {
                    this.$message({
                        message: '请选择时间段',
                        type: 'error',
                        duration: 3 * 1000
                    })
                    return
                }

                this.isLoading = true
                // 模拟fetch请求数据....
                await factorExpenseRecord(query).then((data) => {
                    this.condition.total= parseInt(data.total)
                    this.condition.per_page = parseInt(data.per_page)
                    let listData = data.data
                    for (let i in listData) {
                        let row = listData[i]
                        row.site_name = row.site_name.length > 0 ? row.site_name :'--'
                        row.fee_type = row.fee_type=='0' ? '通话费用' : '低消预扣'
                        row.created_at = parseTime(new Date(row.created_at), '{y}-{m}-{d} {h}:{i}:{s}')
                        row.paid_amount = row.paid_amount / 100
                        row.payable_amount = row.payable_amount / 100
                    }
                    this.list = listData
                })
                this.isLoading = false
            },
            checkDate (value) {
                this.condition = Object.assign({}, this.condition, {
                    timeStamp: value,
                    time: ''
                })
            },
            currentChange (index) {
                this.condition.page = index
                this.initData()
            },
            async download () {
                import('@/vendor/Export2Excel').then(async excel => {
                    const tHeader = ['代理商名称','消费站点','消费类型','应付金额（元）','实付金额（元）','时间']
                    const filterVal = ['factor_name','site_name', 'fee_type', 'payable_amount', 'paid_amount','created_at']
                    let list = []
                    let query = {
                        factor_id : this.condition.id,
                        export : 1,
                        page : 1,
                        per_page : 999
                    }
                    if (this.condition.timeStamp.length > 0) {
                        query.time_quantum = this.condition.timeStamp == 'month' ? 30 : 60
                    } else if(this.condition.time && this.condition.time.length > 0) {
                        query.start_time = Date.parse(new Date(this.condition.time[0]))/1000
                        query.end_time = Date.parse(new Date(this.condition.time[1]))/1000
                    } else {
                        this.$message({
                            message: '请选择时间段',
                            type: 'error',
                            duration: 3 * 1000
                        })
                        return
                    }
                    this.isLoading = true
                    // 模拟fetch请求数据....
                    await factorExpenseRecord(query).then((data) => {
                        let listData = data.data
                        for (let i in listData) {
                            let row = listData[i]
                            row.site_name = row.site_name.length > 0 ? row.site_name :'--'
                            row.fee_type = row.fee_type=='0' ? '通话费用' : '低消预扣'
                            row.created_at = parseTime(new Date(row.created_at), '{y}-{m}-{d} {h}:{i}:{s}')
                            row.paid_amount = row.paid_amount / 100
                            row.payable_amount = row.payable_amount / 100
                        }
                        list = listData
                    })
                    const formatJson = (filterVal) => {
                        return list.map(v => filterVal.map(j => {
                            return v[j]
                        }))
                    }
                    let name = ''
                    if (this.condition.timeStamp.length > 0) {
                        let time_end = new Date(new Date().setHours(0, 0, 0, 0)).getTime()
                        let time_quantum = this.condition.timeStamp == 'month' ? 30 : 60
                        let time_start = time_end - time_quantum * 3600 * 24 * 1000
                        name += parseTime(new Date(time_start), '{y}-{m}-{d}') + '至' + parseTime(new Date(time_end), '{y}-{m}-{d}')
                    } else {
                        name += parseTime( new Date(this.condition.time[0]), '{y}-{m}-{d}') + '至' + parseTime( new Date(this.condition.time[1]), '{y}-{m}-{d}')
                    }
                    name += this.condition.name+'消费明细'
                    const data = formatJson(filterVal)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: name
                    })
                    this.isLoading = false
                })
            },
        }
    }
</script>
